import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { DateControl } from "@tiny/components";
import { useStyles } from "../Value.styles";

interface DateRangeValueProps {
  prefixName: string;
  disabled?: boolean;
}

function DateRangeValue(props: DateRangeValueProps) {
  const { prefixName, disabled } = props;

  const classes = useStyles();

  const value = useWatch({
    name: `${prefixName}.value`,
  });

  const { trigger } = useFormContext();

  const nameFrom = `${prefixName}.value.value[0]`;

  const nameTo = `${prefixName}.value.value[1]`;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const ninetyDaysAgo = new Date(today.getTime() - 90 * 24 * 60 * 60 * 1000);

  const validateDate = (v: number | string | null) => {
    if (typeof v === "number" && !isNaN(v)) {
      const date = new Date(v);
      date.setHours(0, 0, 0, 0);
      if (date > today) {
        return "Date cannot be in the future";
      }
      if (date < ninetyDaysAgo) {
        return "Date cannot be more than 90 days in the past";
      }
    }
  };

  const validateTo = (v: number | string | null) => {
    const fromError = validateDate(v);
    if (fromError) return fromError;

    if (typeof v === "number" && !isNaN(v)) {
      const toDate = new Date(v);
      toDate.setHours(0, 0, 0, 0);
      const fromDate = new Date(value?.value?.[0]);
      fromDate.setHours(0, 0, 0, 0);
      if (fromDate > toDate) {
        return "To date must be after From date";
      }
    }
  };

  React.useEffect(() => {
    trigger([nameFrom, nameTo]);
  }, [trigger, nameFrom, nameTo, value]);

  return (
    <div className={classes.root}>
      <DateControl
        name={nameFrom}
        className={classes.field}
        placeholder="From"
        aria-label="Condition from"
        showHelperTextMargin
        required
        disabled={disabled}
        validate={validateDate}
        minDate={ninetyDaysAgo}
        maxDate={today}
      />
      <DateControl
        name={nameTo}
        className={classes.field}
        placeholder="To"
        aria-label="Condition to"
        showHelperTextMargin
        required
        validate={validateTo}
        disabled={disabled}
        minDate={ninetyDaysAgo}
        maxDate={today}
      />
    </div>
  );
}

export default DateRangeValue;
